import { render, staticRenderFns } from "./ProductExtAttr.vue?vue&type=template&id=66de195a&scoped=true&"
import script from "./ProductExtAttr.vue?vue&type=script&lang=js&"
export * from "./ProductExtAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66de195a",
  null
  
)

component.options.__file = "ProductExtAttr.vue"
export default component.exports